import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getComplaint = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Complaint?fields=["name","complaints"]'
  );
  return data;
});

export const addComplaint = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Complaint',
    //  `/api/resource/Symptoms`,
    body
  );
  return data;
});
export const updateComplaint = catchAsync(async ({ body, id }) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Complaint/${id}`,
    body
  );
  return data;
});
export const deleteComplaint = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    // `/api/method/technoerp.services.delete_symptoms?id=${id}`
    `/api/resource/Complaint/${id}`
  );
  return data;
});

export const getComplaintById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Complaint/${id}`);
  return data;
});
